import { ServiceContact } from './ServiceContact';
import { ServiceTestimonials } from './ServiceTestimonials';
import { ServiceBenefits } from './ServiceBenefits';
import { RitualSteps } from './RitualSteps';


export const ReturnAffectifContent = ({ handleWhatsAppClick }) => (
<section className="py-12 px-4 bg-gradient-to-b from-black to-gray-950">
        <div className="container mx-auto max-w-4xl">
          <article className="prose prose-invert max-w-none">
            <h2 className="text-3xl font-bold text-red-500 mb-6">
              Qu'est-ce que le Retour Affectif ?
            </h2>
            <p className="text-gray-300 leading-relaxed mb-6">
              Le <strong className="text-yellow-400">retour affectif</strong> est un rituel spirituel puissant pratiqué par le <strong className="text-white">marabout africain Maître Diamma</strong> 
              pour ramener l'être aimé. Que votre ex soit parti avec quelqu'un d'autre, qu'il vous ignore complètement ou qu'il refuse de vous parler, 
              les rituels de <strong className="text-yellow-400">retour affectif rapide</strong> de ce <strong className="text-white">sorcier vaudou</strong> créent un lien spirituel 
              et émotionnel irrésistible pour récupérer votre amour perdu.
            </p>

            <h2 className="text-3xl font-bold text-red-500 mb-6 mt-12">
              Comment Fonctionne le Rituel de Retour Affectif ?
            </h2>
            <p className="text-gray-300 leading-relaxed mb-6">
              Le <strong className="text-white">grand marabout Maître Diamma</strong> utilise des rituels ancestraux de <strong className="text-yellow-400">magie blanche</strong> 
              et de <strong className="text-yellow-400">magie rouge</strong> transmis de génération en génération. Ces rituels de <strong className="text-white">sorcellerie vaudou</strong> 
              agissent sur le plan astral et énergétique pour influencer les sentiments de votre ex et le ramener vers vous.
            </p>

            <RitualSteps />

            <ServiceBenefits />

            <ServiceTestimonials />

            <ServiceContact handleWhatsAppClick={handleWhatsAppClick} />
          </article>
        </div>
      </section>
);
